// @file 書き出し領域の計算に必要なユーティリティ関数

import maplibregl from 'maplibre-gl';
import { getCamera } from './maplibre-style'
import { AspectRatio, ExportOptions, Margin } from '../types';

export const DEFAULT_MARGIN = 100

export const getCurrentMargin = (
  map: maplibregl.Map,
  aspectRatio: AspectRatio
): Margin => {
  const clientRect = map.getContainer().getBoundingClientRect()

  let targetWidth: number
  let targetHeight: number
  if (
    (clientRect.height * aspectRatio[0]) / aspectRatio[1] >
    clientRect.width
  ) {
    targetWidth = clientRect.width - DEFAULT_MARGIN * 2
    targetHeight = (targetWidth * aspectRatio[1]) / aspectRatio[0]
  } else {
    targetHeight = clientRect.height - DEFAULT_MARGIN * 2
    targetWidth = (targetHeight * aspectRatio[0]) / aspectRatio[1]
  }
  return {
    horizontal: (clientRect.width - targetWidth) / 2,
    vertical: (clientRect.height - targetHeight) / 2,
  }
}

export const margin2exportOptions = (
  margin: Margin,
  map: maplibregl.Map,
  aspectRatio: number
): ExportOptions | null => {
  if (margin) {
    const clientRect = map.getContainer().getBoundingClientRect()
    const left = margin.horizontal
    const top = margin.vertical
    const right = clientRect.right - clientRect.left - margin.horizontal
    const bottom = clientRect.bottom - clientRect.top - margin.vertical
    const leftTopPoint = new maplibregl.Point(left, top)
    const rightTopPoint = new maplibregl.Point(right, top)
    const rightBottomPoint = new maplibregl.Point(right, bottom)
    const leftBottomPoint = new maplibregl.Point(left, bottom)
    const leftTopLngLat = map.unproject(leftTopPoint).toArray() as [
      lng: number,
      lat: number
    ]
    const rightTopLngLat = map.unproject(rightTopPoint).toArray() as [
      lng: number,
      lat: number
    ]
    const rightBottomLngLat = map.unproject(rightBottomPoint).toArray() as [
      lng: number,
      lat: number
    ]
    const leftBottomLngLat = map.unproject(leftBottomPoint).toArray() as [
      lng: number,
      lat: number
    ]
    return {
      mapRect: [
        leftTopLngLat,
        rightTopLngLat,
        rightBottomLngLat,
        leftBottomLngLat,
      ],
      aspectRatio,
      cameraOptions: getCamera(map),
      containerSize: {
        outerWidth: clientRect.width,
        outerHeight: clientRect.height,
        margin,
      },
    }
  } else {
    return null
  }
}
